import * as React from "react"
const BigDipper = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    transform="rotate(180)"
    viewBox="0 0 64 64"
    {...props}
  >
    <path
      fill="#1d1d1b"
      d="M59.05 38.69c-.71-3.37-3.34-3.15-4-3.06a11.22 11.22 0 0 0-1.5.34S35.8 28.72 35.71 28.6A3.34 3.34 0 0 0 34 25a3 3 0 0 0-3.78.75L24 22a3.6 3.6 0 0 0 0-3.16 2.91 2.91 0 0 0-2.87-1.38 4.41 4.41 0 0 0-.78.22l-1.22-3.93s1.31-2.19.09-3.75-3.44-.79-3.84-.38a6.61 6.61 0 0 0-.88 1.66l-4.15-.07A2.41 2.41 0 0 0 7.9 9.44 3.07 3.07 0 0 0 5 13.38c.69 1.91 3.78 2.31 4.72 1.09a3.06 3.06 0 0 0 .85-2s3.71 0 3.68.1a1.85 1.85 0 0 0 1 1.72 3 3 0 0 0 2.13.15l1.78 4.1a2.78 2.78 0 0 0 .06 3.22 3.77 3.77 0 0 0 3.4 1.24l6.56 4.6a1.65 1.65 0 0 0 .25 1.53 2.51 2.51 0 0 0 1.16 1L30 38.6s-2.87.69-1.91 3.28a2.62 2.62 0 0 0 3.19 1.91s12.5 8.5 12.53 8.59a2.89 2.89 0 0 0 2.57 2.44 2.67 2.67 0 0 0 3.28-2.1 12.44 12.44 0 0 0-.28-1.56l6.4-8.81s3.99-.28 3.27-3.66zM48.37 50.13a2.31 2.31 0 0 0-1.91-.41 9.35 9.35 0 0 0-1.37.63l-11.94-7.13s1.5-1.53.56-3a3.38 3.38 0 0 0-2-1.65s.19-7.63.25-7.63a2.62 2.62 0 0 0 1.84-.19C34.9 30.29 35 30 35 30s8.6 4.15 12 5.53 5.91 2.31 5.91 2.31a2.23 2.23 0 0 0 .34 2.06 5.15 5.15 0 0 0 1.41 1.63z"
    />
    <path
      fill="#cbe7f5"
      d="M6.8 11a1.67 1.67 0 0 1 2.63 1.35c.12 1.59-1.31 2.06-2.47 1.25A1.62 1.62 0 0 1 6.8 11z"
    />
    <g fill="#ffe19b">
      <path d="M15.9 10.47a1.66 1.66 0 0 1 2.62 1.35c.13 1.59-1.31 2.06-2.47 1.25a1.62 1.62 0 0 1-.15-2.6zM20.55 18.94a1.67 1.67 0 0 1 2.63 1.35c.12 1.59-1.31 2.06-2.47 1.25a1.62 1.62 0 0 1-.16-2.6zM31.3 26.35a2 2 0 0 1 3.19 1.5c.13 1.59-2 2.19-3.19 1.37a1.84 1.84 0 0 1 0-2.87z" />
    </g>
    <path
      fill="#cbe7f5"
      d="M56.59 37a2 2 0 0 1 .48 3.49c-1.27 1-2.94-.51-2.89-1.92A1.84 1.84 0 0 1 56.59 37zM29.84 40a1.76 1.76 0 0 1 2.77 1.3c.11 1.39-1.76 1.9-2.77 1.2a1.6 1.6 0 0 1 0-2.5z"
    />
    <path
      fill="#ffe19b"
      d="M45.69 51.07a1.76 1.76 0 0 1 2.77 1.3c.1 1.39-1.77 1.9-2.77 1.2a1.59 1.59 0 0 1 0-2.5z"
    />
  </svg>
)
export default BigDipper
